module.exports = __webpack_public_path__ + "static/img/kapasitas-starvan.de1152c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/kapasitas-starvan.png
// module id = 2Jw+
// module chunks = 1